export enum ProgrammeType {
  ITIL = 'ITIL-4',
  PROPATH = 'ProPath',
  OTHER_BEST_PRACTICES = 'OtherBestPractices',
}
